let service = {}

const env = process.env.VUE_APP_SERVER_ENV

if (env == 'production') {
  service.gateway = 'https://gateway.prod.experiencethis.co'
  service.master_venue = 'https://gateway.prod.experiencethis.co/master-venue'
  service.serverless_api = 'https://6pzvgls42l.execute-api.eu-west-2.amazonaws.com/prod'
} else if (env == 'demo') {
  service.gateway = 'https://gateway.demo.experiencethis.co'
  service.master_venue = 'https://gateway.demo.experiencethis.co/master-venue'
  service.serverless_api = 'https://isk8qd35jf.execute-api.eu-west-2.amazonaws.com/demo'
} else if (env == 'uat') {
  service.gateway = 'https://gateway.uat.experiencethis.co/gateway'
  service.master_venue = 'https://gateway.uat.experiencethis.co/master-venue'
  service.serverless_api = 'https://121cajdx68.execute-api.eu-west-2.amazonaws.com/uat'
} else if (env == 'staging') {
  service.gateway = 'http://api.staging.experiencethis.co:4050/api'
  service.master_venue = 'http://api.staging.experiencethis.co:4024/master-venue'
} else if (env == 'local') {
  service.gateway = 'http://localhost:4050/api'
  service.master_venue = 'http://localhost:4024/master-venue'
  service.serverless_api = 'http://localhost:3000/api'
} else {
  // develop / development — default
  service.gateway = 'https://gateway.dev.experiencethis.co'
  service.master_venue = 'http://api.dev.experiencethis.co:4024/master-venue'
  service.serverless_api = 'https://voxzut640l.execute-api.eu-west-2.amazonaws.com/dev'
}

export default service
